import { FreeGameModelBehavior, SlotConstantsBehavior } from "@quest/murka-games-behavior-leopard/dist"

export class FreeGameModel extends FreeGameModelBehavior {
    //
    constructor(serverModel: any) {
        super(serverModel)
        this.setAnimationSequence(["stackSymbolFg", "showAllFrames", "bigWin", "doNextSpinInFreeGame"]);
    }
    public getIsFgBigWin(winAmount?: number): boolean {
        return false;
    }

    getIsBigWin(winAmount?: number): number {
        return 0;
    }
    /**
     * added a else statement as the game do not have any threshould for fg bigwin
     */
    public getWinMeterTickUpDurationFg(evt: any) {
        const winAmount = evt ? evt : this.getCurrentWinAmt();
        if (this.getIsTurboModeOn()) {
            return SlotConstantsBehavior.WINTICKUP_FG_4;
        } else if (winAmount < this.getTotalBet() * SlotConstantsBehavior.WINTICKUP_THRESHOLDS[0]) {
            return SlotConstantsBehavior.WINTICKUP_FG_1;
        } else {
            return SlotConstantsBehavior.WINTICKUP_FG_1;
        }
    }
    //Need to remove this method from behaviour
    public getUserGameCloseData() {
        //
    }

}

